import { render, staticRenderFns } from "./selfAccoutOpen.vue?vue&type=template&id=065f649e"
import script from "./selfAccoutOpen.vue?vue&type=script&lang=js"
export * from "./selfAccoutOpen.vue?vue&type=script&lang=js"
import style0 from "./selfAccoutOpen.vue?vue&type=style&index=0&id=065f649e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports